import React, { ReactNode } from 'react'
import { connect, DispatchProp } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Page, Spinner } from '../../components'
import { images } from '../../images'
import { AuthenticatedRoutable, IFavoriteResponse, IServiceInfo } from '../../models'
import { urls } from '../../routing'
import { LiteralsService } from '../../services'
import {
  fetchFavoritesAction,
  fetchMoreFavoritesAction,
  fetchServicesAction,
  setFavoriteNewReservationFieldsAction,
  setSelectedFavoriteModalAction
} from '../../store/actions'
import { IStoreState } from '../../store/states'
import { Card } from './Card'
import StyledSection from './styles'
import { handleBottomScroll } from '../../helpers'
import { appsStyleSelected } from '../../helpers/app'

interface IProps extends DispatchProp<any>, RouteComponentProps {
  isFetchingFavorites: boolean
  isFetchingMoreFavorites: boolean
  isPenalized: boolean
  favorites: IFavoriteResponse[]
  size: number,
  page: number,
  isLoadMoreExist: boolean,
  serviceInfos: IServiceInfo[]
}

class Favorites extends AuthenticatedRoutable<IProps> {
  private get emptyReservations(): ReactNode {
    return (
      <div className="empty-reservations">
        <img src={ images['noFavorites'] } alt={ LiteralsService.get('noReservations') }/>
        <h3>{ LiteralsService.get('noFavorites', true) }</h3>
        <p>{ LiteralsService.get('goToYourListAndMarkFavorites', true) }</p>
      </div>
    )
  }

  private get favoritesContent(): ReactNode {
    const { isFetchingFavorites, isFetchingMoreFavorites, favorites, dispatch } = this.props

    if (isFetchingFavorites) {
      return (
        <article className="spinner-container">
          <Spinner />
        </article>
      )
    } else {
      if (!favorites.length) return this.emptyReservations
      return (
        <>
          {
            favorites.map((favorite, i) => (
              <Card
                key={ i }
                favorite={ favorite }
                onRepeat={ this.repeatFavorite }
                onClick={ () => dispatch(setSelectedFavoriteModalAction(favorite))  }
              />
            ))
          }
          {
            isFetchingMoreFavorites &&
            <article className="spinner-container more">
              <Spinner />
            </article>
          }
        </>
      )
    }
  }

  public componentDidMount() {
    const { dispatch, size, serviceInfos } = this.props
    super.componentDidMount()
    dispatch(fetchFavoritesAction(size, 1))
    window.addEventListener('scroll', this.handleScroll)
    if (serviceInfos.length === 0) dispatch(fetchServicesAction())
  }

  componentWillUnmount(): void {
    window.removeEventListener('scroll', this.handleScroll)
  }

  public render(): ReactNode {
    return (
      <Page className={`authenticated ${appsStyleSelected?.style}`}>
        <StyledSection>
          { this.favoritesContent }
        </StyledSection>
      </Page>
    )
  }

  private repeatFavorite = (favorite: IFavoriteResponse) => {
    const { dispatch, history } = this.props
    dispatch(setFavoriteNewReservationFieldsAction(favorite))
    history.push(urls.newReservationDateStep)
  }

  private handleScroll = () => {
    const { dispatch, size, page, isLoadMoreExist, isFetchingMoreFavorites } = this.props
    if (isLoadMoreExist && !isFetchingMoreFavorites) {
      handleBottomScroll(() => dispatch(fetchMoreFavoritesAction(size, page))) 
    }
  }
}

const mapStateToProps = ({ favorites, newReservation }: IStoreState) => ({
  isFetchingFavorites: favorites.isFetchingFavorites,
  isFetchingMoreFavorites: favorites.isFetchingMoreFavorites,
  favorites: favorites.favorites,
  size: favorites.size,
  page: favorites.page,
  isLoadMoreExist: favorites.isLoadMoreExist,
  serviceInfos: newReservation.serviceInfos
})

export default withRouter(connect(mapStateToProps)(Favorites))
